<fn-modal-header class="modal-header">
  <h5 class="modal-title" mat-dialog-title>Resolve</h5>
  <button
    type="button"
    class="close"
    data-dismiss="modal"
    aria-label="Close"
    (click)="close()"
  >
    <span aria-hidden="true">&times;</span>
  </button>
</fn-modal-header>
<mat-dialog-content class="p-15">
  <div class="row resolveMdl">
    <div class="col-12 mb-5">
      <span class="heading">Product : </span> 
      <span class="body">{{ this.dialogData.resolve.product }}</span> 
    </div>
    <div class="col-12 mb-5">
     <span class="heading">Schema : </span> 
      <span class="body">{{ resolveArr.schema }}</span> 
    </div>
    <div class="col-12 mb-5">
      <span class="heading">Source : </span> 
      <span class="body">{{ this.dialogData.resolve.source }}</span> 
    </div>
    <div class="col-12 mb-5">
      <span class="heading">Description : </span> 
      <span class="body">{{ resolveArr.description }}</span> 
    </div>
    <div class="col-12 mb-5">
      <span class="heading">lastUpdatedAt : </span> 
      <span class="body">{{ this.dialogData.resolve.lastUpdatedAt }}</span> 
    </div>
    @if(resolveArr.autoResolvable == 'AutoResolvable'){
      <div class="col-12 mb-5">
        <span class="bold  green "> This will be updated at - {{this.dialogData.resolve.nextUpdateTime}}</span>
      </div>
    }
    @if(resolveArr.autoResolvable == 'Resolve Time passed'){
      <div class="col-12 mb-5">
        <span class="bold  red "> This was expected to get updated at - {{this.dialogData.resolve.nextUpdateTime}} . This need to be resolve manually</span>
      </div>
    }
    @if(resolveArr.autoResolvable == 'MannualResolvable'){
      <div class="col-12 mb-5">
        <span class="bold  orange "> This need to be resolve manually.</span>
      </div>
    }
    <div class="col-2">
      <div class="">
        <label>Telegram</label>
        <fn-checkbox
          [(ngModel)]="isSendTelegram"
          (change)="selectionCheck($event)"
          [value]=""
        ></fn-checkbox>
      </div>
    </div>
    <div class="col-10">
      <textarea class="form-control commentArea"
                  placeholder="Add your comment here..."
                  [(ngModel)]="commentObject.textComment"></textarea>
    </div>
  </div>
</mat-dialog-content>
<mat-dialog-actions>
  <div class="row">
    <div class="col-12 pull-end text-end">
      <button class="btn btn-primary  btn-round" (click)="save()">
        Save
      </button>
    </div>
  </div>
</mat-dialog-actions>
